import Highcharts from 'highcharts'
import React, { useEffect } from 'react'
import difficulty from '../../assets/difficulty.svg'
import Card from '../Card/Card'
import './AccuracyDifficulty.css'

const AccuracyDifficulty = (props) => {
    useEffect(() => {
        let accuracy = []
        accuracy.push(props.data.analytics.easyAccuracy)
        accuracy.push(props.data.analytics.mediumAccuracy)
        accuracy.push(props.data.analytics.hardAccuracy)
        Highcharts.chart('accuracyDifficulty', {
            chart: {
                type: 'bar',
                height: props.width - 40,
                width: props.width,
            },
            colors: ['#00b0f5'],
            title: {
                text: '',
            },
            subtitle: {
                text: '',
            },
            xAxis: {
                categories: ['Easy', 'Medium', 'Hard'],
                title: {
                    text: null,
                },
            },
            yAxis: {
                lineColor: '#999',
                lineWidth: 0.5,
                min: 0,
                max: 100,
                title: {
                    text: '',
                    align: 'high',
                },
                labels: {
                    formatter: function () {
                        return this.value + '%'
                    },
                },
            },
            tooltip: {
                valueSuffix: ' percentage',
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        color: 'black',
                        padding: 0,
                        formatter: function (val) {
                            if (this.y >= 90) {
                                val.y = -15
                            }
                            return this.y + '%'
                        },
                    },
                },
            },
            credits: {
                enabled: false,
            },
            series: [
                {
                    data: accuracy,
                    showInLegend: false,
                    pointWidth: 13,
                },
            ],
        })
    }, [])

    return (
        <div className="overallaccuracy">
            <Card>
                <div className="card-header">
                    <div className="card-overallaccuracy-text">
                        <img src={difficulty} />
                        &nbsp;&nbsp;Accuracy - Diffculty level wise
                    </div>
                </div>
                <div id="accuracyDifficulty"></div>
            </Card>
        </div>
    )
}

export default AccuracyDifficulty
